import type { FC } from "react";
import type { HoursRateConfig } from "../../../utils/models";
import { transformHoursRateConfigsForBackend } from "../../../utils/wageRules/forBackend";
import { hoursRateConfigFromApi } from "../../../utils/wageRules/fromApi";
import { getHoursRateConfigReasons } from "../../../utils/wageRules/validations";
import { matchHoursRateRows } from "./deepLinkRowMatchers";
import { HoursRateConfigTable } from "./HoursRateConfigTable";
import { useSaveHoursRateConfig } from "./useWageRulesConfig";
import { type RuleSectionProps, WageRulesSection, type WageRulesSectionConfig } from "./WageRulesSection";

const HOURS_RATE_SECTION: WageRulesSectionConfig<HoursRateConfig> = {
	section: "hours_rate",
	stored: (settings) => settings.hoursRateConfig,
	fromApi: hoursRateConfigFromApi,
	forBackend: transformHoursRateConfigsForBackend,
	reasons: (rows) => getHoursRateConfigReasons(rows),
	Table: HoursRateConfigTable,
	explainerKey: "team.wageSettings.hoursRate.explainer",
	dataTestId: "team-wage-settings-hours-rate",
	matchDeepLinkRows: matchHoursRateRows,
};

/** DAT-905 · Hours rates (wage differentials by time of day, role, weekend, and so on) on Team → Wage Settings. */
export const HoursRateSection: FC<RuleSectionProps> = ({ settings, isReadOnly, deepLink }) => {
	const save = useSaveHoursRateConfig();
	return <WageRulesSection config={HOURS_RATE_SECTION} settings={settings} save={save} isReadOnly={isReadOnly} deepLink={deepLink} />;
};
